/* eslint-disable unicorn/prefer-event-target */
import { createContext, useContext, useEffect, useState } from "react";
import type { TabView } from "../../../entities/posts/components/templates/post-form-base-template";
import { EventEmitter } from "../../../@idea-planner/core/service/event-emitter";

interface BulkCreatePostContextType {
  rightPanelTabEventEmitter: EventEmitter<{ onRightPanelTabChange: TabView }>;
}

export const BulkCreatePostContext = createContext<BulkCreatePostContextType>({
  rightPanelTabEventEmitter: new EventEmitter<{
    onRightPanelTabChange: TabView;
  }>(),
});

export const useBulkCreatePostContextProvider = () => {
  const [context] = useState<BulkCreatePostContextType>({
    rightPanelTabEventEmitter: new EventEmitter<{
      onRightPanelTabChange: TabView;
    }>(),
  });
  return context;
};

export const useSelectedRightPanelTab = (defaultView: TabView) => {
  const context = useContext(BulkCreatePostContext);
  const [tabView, setTabView] = useState<TabView>(defaultView);
  useEffect(() => {
    return context.rightPanelTabEventEmitter.on(
      "onRightPanelTabChange",
      (view) => {
        setTabView(view);
      }
    );
  }, [context]);
  return {
    tabView,
    setTabView: (view: TabView) => {
      context.rightPanelTabEventEmitter.emit("onRightPanelTabChange", view);
    },
  };
};
